interface SeoInput {
  title: string;
  description?: string;
  image?: string;
  url?: string;
}

/**
 * Builds the `meta` array for a route's `head()` — title, description, Open
 * Graph and Twitter tags. These are baked into the prerendered HTML so
 * crawlers and social scrapers see them without running JS.
 */
export function seo({ title, description, image, url }: SeoInput) {
  return [
    { title },
    ...(description ? [{ name: "description", content: description }] : []),
    { property: "og:type", content: "website" },
    { property: "og:title", content: title },
    { property: "og:site_name", content: "Linqx" },
    ...(description
      ? [{ property: "og:description", content: description }]
      : []),
    ...(url ? [{ property: "og:url", content: url }] : []),
    {
      name: "twitter:card",
      content: image ? "summary_large_image" : "summary",
    },
    { name: "twitter:title", content: title },
    ...(description
      ? [{ name: "twitter:description", content: description }]
      : []),
    ...(image
      ? [
          { property: "og:image", content: image },
          { name: "twitter:image", content: image },
        ]
      : []),
  ];
}
